module.exports = __webpack_public_path__ + "img/DateRange.d44c13e6.svg";